import {
  BoxV2 as Box,
  ButtonV2 as Button,
  Flex,
  TextInputV2 as TextInput,
} from 'portal-commons';
import { FC } from 'react';
import { useForm } from 'react-hook-form';

import { useControllers } from './hooks';
import { CampaignComplaintFormValues } from './types';
import { CampaignDetail } from '@/apis/core';

interface CampaignComplaintFormHUProps {
  campaign: CampaignDetail;
  onCancel?: () => void;
  onSubmit?: (explanation: string) => void;
}

const CampaignComplaintFormHU: FC<CampaignComplaintFormHUProps> = ({
  campaign,
  onCancel,
  onSubmit,
}) => {
  const {
    control,
    formState: { isValid, errors },
    handleSubmit,
  } = useForm<CampaignComplaintFormValues>({
    mode: 'onChange',
  });
  const { explanation, setExplanation, validateExplanation, explanationError } =
    useControllers(control);

  const handleValid = () => {
    onSubmit?.(explanation);
  };

  return (
    <form
      style={{ height: '100%' }}
      noValidate
      onSubmit={handleSubmit(handleValid)}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          gap: 'xl',
          height: '100%',
          color: 't.black70',
          fontWeight: 400,
          lineHeight: 'normal',
        }}
      >
        <Flex
          sx={{
            flex: 1,
            flexDirection: 'column',
            gap: 'xl',
            overflow: 'auto',
          }}
        >
          <Flex
            sx={{
              flexDirection: 'column',
              gap: 'xs',
            }}
          >
            <Box
              sx={{
                color: 't.black90',
                fontWeight: 500,
                fontSize: '28px',
              }}
            >
              File Complaint
            </Box>
            <Box sx={{ fontSize: 'H400' }}>
              Complaints will be visible to all parties in the connectivity
              chain.
            </Box>
          </Flex>

          <Box sx={{ fontSize: 'H300' }}>Indicates a required field*</Box>

          <TextInput readOnly label="Program ID" value={campaign.uid} />
          <TextInput readOnly label="CSP" value={campaign.cspUid} />
          <TextInput
            readOnly
            label="Brand DBA Name"
            value={campaign.brandName}
          />
          <TextInput
            required
            multiline
            error={!!explanationError?.message}
            minRows={3}
            maxRows={3}
            label="Detailed Explanation"
            note={explanationError?.message}
            value={explanation}
            onChange={setExplanation}
            onBlur={validateExplanation}
          />
        </Flex>

        <Flex sx={{ justifyContent: 'flex-end', gap: 'l' }}>
          <Button shape="square" variant="outline" size="lg" onClick={onCancel}>
            Cancel
          </Button>
          <Button shape="square" size="lg" disabled={!isValid}>
            File Complaint
          </Button>
        </Flex>
      </Flex>
    </form>
  );
};

export default CampaignComplaintFormHU;
